export class AuthConstants{
    public static readonly AUTH = 'userDataKey';
    public static readonly CART = 'cartUser';
    public static CARTLENGHT = 0;
    public static apiIpAddress = "http://api.ipify.org/?format=json";
    public static epubLocation = "Qxu%30Ls_epubLocation";
};